import { Attr, Model } from "spraypaint";
import ApplicationRecord from "./ApplicationRecord";

@Model()
class InviteUser extends ApplicationRecord {
  static jsonapiType = "users/invite";

  @Attr() firstName: string;

  @Attr() lastName: string;

  @Attr() email: string;

  @Attr() type: "RecruiterUser" | "EmployerUser";

  @Attr() admin: boolean;

  @Attr() invitedById: number;

  @Attr() companyId: number;
}

export default InviteUser;
